export default "__VITE_ASSET__ASZekZhh__"